import "./Projects.css";

const Projects = () => {
  return (
    <div className="projects">
      <h1>I like data</h1>
      <p>
        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;learning
      </p>
      <p>
        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;minimalism
      </p>
      <p>
        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;science
      </p>
      <p>
        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;silence
      </p>
      <p>
        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;simplicity
      </p>
      <p>
        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;thinking
      </p>
    </div>
  );
};

export default Projects;